import { Filter } from '@/interfaces/filter.interface'
import { APICountry } from '@/models/api/country.model'
import { CountriesServices } from '@/services/modules/countries.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class CountriesStore extends VuexModule {
    countries: object[] = []
    countriesPaginate: object[] = []
    countryForm: object|null = null

    @Mutation
    updateCountries (newCountries: object[]) {
        this.countries = newCountries
    }

    @Mutation
    updateCountriesPaginate (newCountries: object[]) {
        this.countriesPaginate = newCountries
    }

    @Mutation
    updateCountry (newCountry: object) {
        this.countryForm = newCountry
    }

    @Action
    getCountries () {
        return new Promise((resolve) => {
            CountriesServices.getCountries()
                .then(resp => {
                    store.commit('updateCountries', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCountriesPaginate (params: {
        page: number;
        filters?: Filter[];
        limit: number;
        sortBy: string;
        sort: string;
    }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            CountriesServices.getCountriesPaginate(newParams)
                .then(resp => {
                    store.commit('updateCountriesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getCountriesById (id: number) {
        return new Promise((resolve) => {
            CountriesServices.getCountriesById(id)
                .then(resp => {
                    store.commit('updateCountry', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editCountries (params: APICountry) {
        params = new APICountry(params)

        return new Promise((resolve) => {
            if (!(params instanceof APICountry)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CountriesServices.editCountries(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createCountries (params: APICountry) {
        params = new APICountry(params)

        return new Promise((resolve) => {
            if (!(params instanceof APICountry)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            CountriesServices.createCountries(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteCountries (id: number) {
        return new Promise((resolve) => {
            CountriesServices.deleteCountries(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreCountries (id: number) {
        return new Promise((resolve) => {
            CountriesServices.restoreCountries(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
